// import "./../styles/header.css";

// export default function Footer() {
//   return (
//     <footer className="footer">
//       <p>© 2025 Notes App by Deepa</p>
//     </footer>
//   );
// }



import { Box, Container, Typography, IconButton } from "@mui/material";
import { GitHub, LinkedIn, Email } from "@mui/icons-material";

export default function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: "primary.main",
        color: "white",
        py: 3,
        mt: "auto",
        // background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
         background: "linear-gradient(135deg, #2e0d35ff 0%, #764ba2 100%)"
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            // display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: "center",
            // gap: 2,
          }}
        >
          {/* Copyright */}
          <Typography variant="body1" align="center">
            © 2025 MyKe Notes App by Deepa
          </Typography>

          {/* Social Links */}
          {/* <Box sx={{ display: "flex", gap: 1 }}>
            <IconButton
              sx={{
                color: "white",
                "&:hover": {
                  backgroundColor: "rgba(255,255,255,0.1)",
                },
              }}
              aria-label="GitHub"
            >
              <GitHub fontSize="small" />
            </IconButton>
            <IconButton
              sx={{
                color: "white",
                "&:hover": {
                  backgroundColor: "rgba(255,255,255,0.1)",
                },
              }}
              aria-label="LinkedIn"
            >
              <LinkedIn fontSize="small" />
            </IconButton>
            <IconButton
              sx={{
                color: "white",
                "&:hover": {
                  backgroundColor: "rgba(255,255,255,0.1)",
                },
              }}
              aria-label="Email"
            >
              <Email fontSize="small" />
            </IconButton>
          </Box> */}
        </Box>
      </Container>
    </Box>
  );
}
